'use client';

import { useEffect, useRef, useState } from 'react';

const words = [
  'Stop',
  'wasting',
  'hours',
  'on',
  'spreadsheet',
  'calculations.',
  'Start',
  'quoting',
  'with',
  'real-time',
  'market',
  'pricing',
  'that',
  'adapts',
  'to',
  'your',
  'local',
  'area',
  'and',
  'learns',
  'from',
  'contractor',
  'behavior,',
  'not',
  'static',
  'formulas.',
];

export default function ValueProposition() {
  const [activeWords, setActiveWords] = useState<Set<number>>(new Set());
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleScroll = () => {
      if (!sectionRef.current) return;

      const rect = sectionRef.current.getBoundingClientRect();
      const winH = window.innerHeight;
      const startReveal = winH * 0.9;
      const endReveal = winH * 0.4;

      let progress = (startReveal - rect.top) / (startReveal - endReveal);
      progress = Math.max(0, Math.min(1, progress));

      const activeCount = Math.floor(progress * words.length);
      const newActiveWords = new Set<number>();

      for (let i = 0; i < activeCount; i++) {
        newActiveWords.add(i);
      }

      setActiveWords(newActiveWords);
    };

    window.addEventListener('scroll', handleScroll);
    handleScroll(); // Initial check

    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <section
      ref={sectionRef}
      className="section-padding bg-gradient-to-b from-muted/30 to-background relative overflow-hidden"
    >
      <div className="container-custom">
        <div className="max-w-5xl mx-auto text-center">
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-heading leading-tight tracking-tight">
            {words.map((word, index) => {
              const isActive = activeWords.has(index);
              const isHighlight =
                word === 'real-time' ||
                word === 'market' ||
                word === 'pricing' ||
                word === 'behavior,';

              return (
                <span
                  key={`word_${index}`}
                  className={`inline-block mx-2 transition-all duration-500 ${
                    isActive ? 'opacity-100' : 'opacity-20'
                  } ${
                    isHighlight && isActive
                      ? 'text-primary font-bold' :'text-foreground'
                  }`}
                >
                  {word}
                </span>
              );
            })}
          </h2>
        </div>
      </div>

      {/* Decorative elements */}
      <div className="absolute top-1/4 left-10 w-64 h-64 bg-primary/5 blur-[100px] rounded-full" />
      <div className="absolute bottom-1/4 right-10 w-64 h-64 bg-secondary/5 blur-[100px] rounded-full" />
    </section>
  );
}